import { useSetLayoutProps } from '@hwm/ui-lib';
import { AppLayoutProps } from '@shared/components/Layout/AppLayout';
import { SidebarKeys } from '@shared/components/Sidebar/Sidebar.utils';
import { useCallback, useEffect, useState } from 'react';

export const useSidebar = () => {
  const [setLayoutProps, { sidebar, ...prev }] = useSetLayoutProps<AppLayoutProps>();

  const [showSidebarData, setShowSidebarData] = useState(false);

  const handleSidebarState = useCallback(
    (newState: boolean) => {
      setLayoutProps({ ...prev, sidebar: { ...sidebar, state: newState } });
    },
    [setLayoutProps, sidebar, prev]
  );

  const handleSidebarSection = useCallback(
    (newSection: SidebarKeys) => {
      setLayoutProps({ ...prev, sidebar: { ...sidebar, section: newSection } });
    },
    [setLayoutProps, sidebar, prev]
  );

  const handleForceFavDisplay = useCallback(
    (forceFav: boolean) => {
      setLayoutProps({ ...prev, sidebar: { ...sidebar, forceFavDisplay: forceFav } });
    },
    [setLayoutProps, sidebar, prev]
  );

  useEffect(() => {
    setShowSidebarData(false);
    const timeout = setTimeout(() => {
      sidebar.state && setShowSidebarData(true);
    }, 400);

    return () => {
      clearTimeout(timeout);
    };
  }, [sidebar.state]);

  return {
    showSidebarData,
    sidebar,
    handleSidebarState,
    handleSidebarSection,
    handleForceFavDisplay,
  };
};
